<script>
  import Button from './common/Button.svelte'

  import { step, stats, history } from "./stores.js";

  import data from "./data";

  import { setNewStatValue, parseText, getLogicGotoStep } from "./helpers";

  let question;
  let answers;
  let isAdv;
  let advText;

  step.subscribe((newStep) => {
    const newData = data[newStep];
    if (newData) {
      question = newData.question;
      answers = newData.answers;
      isAdv = newData.isAdv;
      advText = newData.advText;
    }
  });

  const handleReaction = (reaction) => {
    Object.keys(reaction).forEach((key) => {
      if (reaction[key]) {
        setNewStatValue(reaction[key], stats[key]);
      }
    });
  };

  const handleAnswer = (answer, answerIndex) => {
    if (answer.reaction) {
      handleReaction(answer.reaction);
    }
    history.set({
      ...$history,
      [$step]: answerIndex,
    });

    let nextStep = null;

    if ("goto" in answer) {
      nextStep = answer.goto;
    }
    if ("logicGoto" in answer) {
      nextStep = getLogicGotoStep(answer.logicGoto, $history);
    }

    if (nextStep) {
      step.set(nextStep);
    }
  }
</script>

<div class="card card--main dekstop">
  <div class="card__main">
    <div class="card__img">
      <img src={`./img/slides/${$step}.png`} alt={`step-${$step}`} />
    </div>
    {#if isAdv !== true}
      {#each parseText(question) as questionP}
        <p>{questionP}</p>
      {/each}
    {:else}
      {#each parseText(advText) as advP}
        <p>{advP}</p>
      {/each}
    {/if}
  </div>
  {#if isAdv !== true}
    {#each answers as answer, i}
      <Button onClick={() => handleAnswer(answer, i)} text={answer.text} />
    {/each}
  {:else}
    <Button onClick={() => handleAnswer(answers[0], 0)} text="Ясно, понятно" />
  {/if}
</div>
